import { render } from "./BusinessRules.vue?vue&type=template&id=50fd1b08"
import script from "./BusinessRules.vue?vue&type=script&lang=js"
export * from "./BusinessRules.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__